module.exports = __webpack_public_path__ + "static/media/street-triple.9dfe5a5a.jpg";